/**
 * @author      esraa.afifi@zumper.com (Esraa Afifi)
 * @copyright   Copyright (c) 2021, Zumper
 */

import { IconProps } from '../../types'

export const Hamburger = ({ size = 14, fill = '#726F6C', ...rest }: IconProps) => {
  return (
    <svg
      fill="none"
      height={size}
      viewBox={`0 0 ${size} 12`}
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect fill={fill} height="2" rx="1" width={size} />
      <rect fill={fill} height="2" rx="1" width={size} y="5" />
      <rect fill={fill} height="2" rx="1" width={size} y="10" />
    </svg>
  )
}
